import Navbar from "./components/navbar/Navbar";
import Header from "./components/header/Header";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import Summary from "./components/screens/Summary";
import Footer from "./components/footer/Footer";

import Err404 from "./components/screens/Err404";

import ProjectPartner from "./components/screens/ProjectPatner";
import PatentPublication from "./components/screens/PatentPublication";
import Investigators from "./components/screens/Investigators";
import Scholars from "./components/screens/Scholars";
import TrainedManpower from "./components/screens/TrainedManpower";
import LabSetup from "./components/screens/LabSetup";
import FieldDemostration from "./components/screens/FieldDemonstration";
import Gallery from "./components/screens/Gallery";
import RoadMap from "./components/screens/RoadMap";

function App() {
  return (
    <BrowserRouter basename='/hmg'>
    <div className="App">
      <Header />
      <Navbar />
      {/* <!-- Overlay effect when opening sidebar on small screens --> */}
      <div className="w3-overlay w3-hide-large w3-animate-opacity" title="close side menu" id="myOverlay"></div>
     
     
      <div className="w3-main">
      <Switch>
        <Route exact path="/" component={Summary}/>
        <Route path="/summary" component={Summary}/>
        <Route path="/projectpartner" component={ProjectPartner}/>
        <Route path="/patentpublication" component={PatentPublication}/>
        <Route path="/roadmap" component={RoadMap}/>
        <Route path="/investigators" component={Investigators}/>
        <Route path="/scholars" component={Scholars}/>
        <Route path="/trainedmanpower" component={TrainedManpower}/>
        <Route path="/labsetup" component={LabSetup}/>
        <Route path="/fielddemonstration" component={FieldDemostration}/>
        <Route path="/gallery" component={Gallery}/>
        <Route path="*" component={Err404} />
        
        
        {/* <Route path='/404' component={Err404} />
        <Redirect to="/404" /> */}

        
      </Switch>
      <Footer />
      </div>
   
      
      
    </div>
    </BrowserRouter>
    
  );
}

export default App;
